import { observer } from 'mobx-react';
import { makeAutoObservable } from 'mobx';

import Step1 from './Step1';

import s from './styles.module.scss';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';
import { authorizedRequest } from 'utils/authorization';
import userStore from 'store/User';

export const isExist = (value: any) => !(value === null || value === undefined);

class AppInfoBC {
  constructor() {
    makeAutoObservable(this);
  }

  isModalFillShowed = false;
  page = 1;

  values = {
    distribution: {
      appleStore: false,
      appleStoreComment: '',
      googleStore: false,
      googleStoreComment: '',
      steam: false,
      steamComment: '',
      other: false,
      otherComment: '',
    },
    monetization: [] as string[],
    otherMonetizationComment: '',
    uaSpend: {
      facebook: false,
      googleAds: false,
      appleSearchAds: false,
      snapchat: false,
      tikTok: false,
      unityAds: false,
      dontKnow: false,
      other: false,
      otherComment: '',
    },
    mmp: {
      adjust: false,
      appsflyer: false,
      tenjin: false,
      kochava: false,
      branch: false,
      firebase: false,
      dontKnow: false,
      other: false,
      otherComment: '',
    },
    additionalInfo: '',
  };

  isStepIsValid = {
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
  };

  isDataSended = false;

  get isLastStep() {
    return this.page === 5;
  }

  get isAppInfoValid() {
    return (
      (this.isStepIsValid[1] &&
        this.isStepIsValid[2] &&
        this.isStepIsValid[3] &&
        this.isStepIsValid[4] &&
        this.isStepIsValid[5]) ||
      ([
        this.values.distribution.appleStoreComment,
        this.values.distribution.googleStoreComment,
        this.values.distribution.steamComment,
        this.values.distribution.otherComment,
      ].some((el) => el?.length > 0) &&
        this.values.monetization.length > 0 &&
        Object.values(this.values.uaSpend).some((el) => el === true) &&
        Object.values(this.values.mmp).some((el) => true))
    );
  }

  get isSteamApplied() {
    return isExist(this.values.distribution.steam);
  }

  get isMonetizationNotPremium() {
    return false;
    // return this.values.monetization && this.values.monetization !== "Premium";
  }

  getJSON = () => {
    // Формируем массив monetization с учетом комментария к "Other"
    let monetization = [...this.values.monetization];

    // Если выбран "Other" и есть комментарий, заменяем "Other" на "Other: комментарий"
    if (
      this.values.monetization.includes('Other') &&
      this.values.otherMonetizationComment?.trim()
    ) {
      monetization = monetization.map((item) =>
        item === 'Other'
          ? `Other: ${this.values.otherMonetizationComment.trim()}`
          : item,
      );
    }

    return {
      distribution: this.values.distribution,
      monetization,
      uaSpend: this.values.uaSpend,
      mmp: this.values.mmp,
      additionalInfo: this.values.additionalInfo,
    };
  };

  async sendData(companyId: string) {
    await authorizedRequest({
      url: `/v1/onboarding/${companyId}/questionary/app`,
      method: 'POST',
      service: 'fca',
      data: this.getJSON(),
    });
  }

  async getData(companyId: string) {
    let result;
    try {
      result = await authorizedRequest({
        url: `/v1/onboarding/${companyId}`,
        method: 'GET',
        service: 'fca',
        data: this.getJSON(),
      });
    } catch (e) {
      console.log(e);
    }

    if (result) {
      if (result?.app_questionary?.distribution !== null) {
        this.values.distribution = result.app_questionary.distribution;
      }

      if (result?.app_questionary?.monetization.length > 0) {
        // Парсим monetization и извлекаем комментарий к "Other" если есть
        this.values.monetization = result.app_questionary.monetization.map(
          (item: string) => {
            // Если элемент начинается с "Other:", извлекаем комментарий
            if (item.startsWith('Other:')) {
              this.values.otherMonetizationComment = item.substring(6).trim();
              return 'Other';
            }
            return item;
          },
        );
      }

      if (result?.app_questionary?.uaSpend !== null) {
        this.values.uaSpend = result.app_questionary.uaSpend;
      }

      if (result?.app_questionary?.mmp !== null) {
        this.values.mmp = result.app_questionary.mmp;
      }

      if (result?.app_questionary?.additionalInfo !== null) {
        this.values.additionalInfo = result.app_questionary.additionalInfo;
      }

      // Не сбрасываем isDataSended если данные уже были отправлены локально
      if (!this.isDataSended) {
        this.isDataSended = userStore?.onboardingSteps?.appGameInfo ?? false;
      }
    }
  }
}

export const appInfoInst = new AppInfoBC();

const AppInfo = observer(() => {
  const getPage = (page: number) => {
    switch (page) {
      case 1:
        return <Step1 />;
      case 2:
        return <Step2 />;
      case 3:
        return <Step3 />;
      case 4:
        return <Step4 />;
      case 5:
        return <Step5 />;
      default:
        return <div />;
    }
  };

  return <div className={s.container}>{getPage(appInfoInst.page)}</div>;
});

export default AppInfo;
